interface PriorityActionItem {
  label: string;
  value: number;
  valueClassName?: string;
}

interface PriorityActionCardProps {
  title: string;
  description: string;
  count: number;
  countClassName: string;
  icon: string;
  iconClassName: string;
  iconBgClassName: string;
  items: PriorityActionItem[];
  footerText?: string;
  footerClassName?: string;
  isLoading?: boolean;
  onClick?: () => void;
}

export const PriorityActionCard = ({
  title,
  description,
  count,
  countClassName,
  icon,
  iconClassName,
  iconBgClassName,
  items,
  footerText,
  footerClassName,
  onClick,
  isLoading = false,
}: PriorityActionCardProps) => {
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-4 min-h-[190px]">
      <div className="flex items-start justify-between">
        <div
          className={`w-9 h-9 rounded-lg flex items-center justify-center ${iconBgClassName}`}
        >
          <i className={`${icon} ${iconClassName} text-xl`}></i>
        </div>

        <span className={`text-2xl font-medium ${countClassName}`}>
          {count}
        </span>
      </div>

      <div className="mt-3">
        <h3 className="text-sm font-semibold text-gray-800">{title}</h3>

        <p className="text-sm text-gray-500 mt-1">{description}</p>
      </div>

      <div className="mt-4 space-y-2">
        {items.map((item) => (
          <div key={item.label} className="flex items-center justify-between">
            <span className="text-sm text-gray-500">{item.label}</span>

            <span
              className={`text-sm font-medium ${
                item.valueClassName ?? "text-gray-800"
              }`}
            >
              {item.value}
            </span>
          </div>
        ))}
      </div>

      <div className="mt-4">
        {footerText && (
          <button
            type="button"
            onClick={onClick}
            className={`text-sm font-medium flex items-center gap-1 hover:underline ${footerClassName ?? ""}`}
          >
            {footerText}
            <i className="ri-arrow-right-line text-base"></i>
          </button>
        )}
      </div>
    </div>
  );
};
